import { MessageCircle } from "lucide-react";
import { useCompany, buildWhatsAppUrl } from "@/lib/useCompany";

export default function WhatsAppFloat() {
  const company = useCompany();
  if (!company.whatsapp) return null;
  return (
    <a
      href={buildWhatsAppUrl(company.whatsapp)}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="Chatear por WhatsApp"
      className="fixed bottom-6 right-6 z-40 bg-vp-red hover:bg-vp-yellow hover:text-[#001E62] text-white px-5 py-4 shadow-brutal font-bold uppercase tracking-widest text-xs inline-flex items-center gap-3 transition-all hover:-translate-y-1 border-2 border-vp-yellow"
    >
      <MessageCircle size={18} />
      Cotizar ahora
    </a>
  );
}
